import {
  AppliedFiltersProps as SharedAppliedFiltersProps,
  AppliedFilters as SharedAppliedFilters,
} from "@flaminem/ui-components";
import { FC } from "react";

import { useT } from "src/internationalization";

export type AppliedFiltersProps = Omit<SharedAppliedFiltersProps, "languageTexts">;

export const AppliedFilters: FC<AppliedFiltersProps> = (props) => {
  const t = useT();

  return (
    <SharedAppliedFilters
      {...props}
      languageTexts={{
        clear: t("component.applied.filters.clear"),
      }}
    />
  );
};
